import routerOptions0 from "/Users/klemen/Desktop/Development/kroznik/monorepo/kroznik_backoffice/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}